import script from "./SALStep2Produccion.vue?vue&type=script&setup=true&lang=js"
export * from "./SALStep2Produccion.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__